import {AppSidebar} from './app-sidebar';
import {Separator} from '@/shadcn_components/ui/separator';
import {SidebarInset, SidebarProvider, SidebarTrigger} from '@/shadcn_components/ui/sidebar';
import {Outlet} from 'react-router';
import AppBreadcrumbs from './AppBreadcrumbs';
import 'react-toastify/dist/ReactToastify.css';
import {ToastContainer} from 'react-toastify';
import Header from './header';
import useAppSettingStore from '@/store/useAppSettingStore';
import { useEffect } from 'react';
import { apiService } from '@/lib/ApiService';
import { useMutation, useQuery } from '@tanstack/react-query';

export default function Page() {
  // load setting
  const {setGeneralSettings, loaded, setLoaded} = useAppSettingStore();
  useQuery({
    queryKey: ['settings', 'general'],
    queryFn: async () => {
      const data = await apiService.settings.load('general');      
      return data;
    },
    onSuccess: (data) => {
      console.log('general settings', data);
      setGeneralSettings(data);
      setLoaded(true);
    },
    onError: (e) => {
      console.error(e);
    },
    enabled: !loaded
  });

  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset className='overflow-auto'>
        <Header />
        <div className="h-[calc(100vh-4rem)]">
          <Outlet />
        </div>
      </SidebarInset>
      {/* Notification */}
      <ToastContainer
        position="bottom-center"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        // pauseOnFocusLoss
        draggable
        // pauseOnHover
        theme="light"
      />
    </SidebarProvider>
  );
}
